import { ChatRequest, JsonExplanationRequest } from "../../repsaApi";
import api from "./chatApi";

export function explainJsonData(
  jsonData: string,
  analysisType: string,
  mode: string,
  timePeriod: string,
  selectedYearText: string,
  category?: string | undefined,
  variableName?: string | undefined,
  variableNames?: string | undefined,
  aggregationType?: string | undefined
) {
  const request = new JsonExplanationRequest({
    jsonData: jsonData,
    analysisType: analysisType,
    mode: mode,
    selectedYearText: selectedYearText,
    timePeriod: timePeriod,
    aggregationType: aggregationType,
    category: category,
    variableNames: variableNames,
    variableName: variableName,
  });
  return api.explainJsonData(request);
}

export function processConversation(
  question: string,
  sessionId?: string | undefined
) {
  const request = new ChatRequest({
    question: question,
    sessionId: sessionId,
  });
  return api.processConversation(request);
}
